import { createSlice } from "@reduxjs/toolkit";

// Это надо удалить, просто пропсами передай
const initialState = {
  //---------// Unit-Economy logic
  skuFiltersParam: {},
  skuOption: "showAll",
  unitEconomicsFilters: {},
};

const innerEconomicGlobal = createSlice({
  name: "innerEconomicGlobal",
  initialState,
  reducers: {
    //---------// Unit-Economy logic
    setSkuOption(state, { payload: { value } }) {
      state.skuOption = value;
    },
    setSkuFiltersParam(state, { payload: { name, value } }) {
      state.skuFiltersParam[name] = value;
    },
    clearSkuFiltersParam(state) {
      state.skuFiltersParam = {};
    },
    setUnitEconomicsFilters: (state, action) => {
      state.unitEconomicsFilters = action.payload;
    },
  },
  //---------//
});

export default innerEconomicGlobal.reducer;

export const { setSkuOption, setSkuFiltersParam, clearSkuFiltersParam, setUnitEconomicsFilters } =
  innerEconomicGlobal.actions;
